<template>
  <div class="bb-user-form"
  >
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-user-form-controls">
      <div class="bb-user-form-controls__title">Employee card</div>
      <i class="icon-edit bb-icon bb-icon_accent" v-if="false"/>
    </div>
    <div class="bb-user-form-header">
      <div class="bb-user-form-header-avatar-wrapper">
        <img :src="imageSrc ? imageSrc : avatarUserDefault"
             class="bb-user-form-header-avatar-wrapper__avatar"
        />
      </div>
      <div class="bb-user-form-header-user-info">
        <div class="bb-user-form-header-user-info__name">
          {{`${fullName}`}}
        </div>
        <div class="bb-user-form-header-user-info__role">
          {{user.role}}
        </div>
      </div>
    </div>
    <div class="bb-user-form-body">
      <div v-for="row in userFormColumn"
           :key="row.id"
      >
        <UserLabel :label="row.prop"
                   :user="user"
                   :row="row"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import avatarUserDefault from '@/assets/images/avatar-user-default-big.png'
import userForm from '../../../../constants/Forms/userForm'
import UserLabel from './UserLabel'
import { get } from 'lodash'
export default {
  name: 'UserForm',
  components: {
    LoaderFly,
    UserLabel
  },
  props: ['user'],
  computed: {
    imageSrc () {
      const image = get(this.user, 'image', {})
      return get(image, 'path', '')
    },

    fullName () {
      const firstName = get(this.user, 'firstName', '')
      const lastName = get(this.user, 'lastName', '')
      const userName = get(this.user, 'username', '')
      return (firstName && lastName) ? `${firstName} ${lastName}` : userName
    }
  },
  data () {
    return {
      loaderRun: false,
      avatarUserDefault: avatarUserDefault,
      userFormColumn: userForm,
      model: {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-user-form {
  @include global-font;
  position: relative;
  display: grid;
  grid-template-rows: 55px 150px 257px auto;
  width: 333px;
  height: calc(100vh - 60px);
  background: $color-white;
  border-radius: 5px;
  z-index: 1;

  &-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid $color-wild-sand;
    min-height: 55px;
    padding: 0 20px;

    &__title {
      color: $color-accent;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
    }
  }

  &-header {
    display: grid;
    grid-template-columns: 115px 1fr;
    align-items: center;
    margin: 25px 20px 14px 25px;

    &-avatar-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      margin-right: 29px;
      height: 100px;

      &__avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
    }

    &-user-info {
      width: 100%;
      display: grid;
      grid-gap: 9px;

      &__name {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: $color-black;
        text-transform: capitalize;
      }

      &__role {
        padding: 4px 6px;
        width: max-content;
        text-transform: capitalize;
        background: rgba($color-denim, 0.14);
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: $color-denim;
        border-radius: 4px;
      }
    }
  }

  &-body {
    padding: 25px 20px;
    border-bottom: 2px solid $color-wild-sand;

    &-row {
      width: 100%;
      display: grid;
      grid-template-columns: 123px auto;
      align-items: flex-start;
      margin-top: 26px;

      &:first-child {
        margin-top: 0;
      }

      &__cell {
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: $color-denim;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Settings/UserCard/UserForm/UserForm.vue